class StickyAtc extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.getAttribute('data-section-id');
    this.priceTarget = this.querySelector('[data-sticky-atc-price]');
    this.button = this.querySelector('[data-sticky-atc-button]');
    this.label = this.querySelector('[data-sticky-atc-label]');
  }

  connectedCallback() {
    this.realButton = document.querySelector('.product-form__submit');
    this.realPrice = document.getElementById('total-price-' + this.sectionId)
      || document.getElementById('price-' + this.sectionId);

    if (!this.realButton) return;

    this.sync();

    this.button.addEventListener('click', () => {
      if (this.realButton.disabled) return;
      this.realButton.click();
    });

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const barVisible = !entry.isIntersecting;
          this.toggleAttribute('data-visible', barVisible);
          this.setAttribute('aria-hidden', barVisible ? 'false' : 'true');
        });
      },
      { rootMargin: '0px 0px -40px 0px' }
    );
    this.observer.observe(this.realButton);

    this.mutationObserver = new MutationObserver(() => this.onSectionChange());
    this.mutationObserver.observe(document.querySelector('.product__info-container'), {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled', 'class']
    });
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
    if (this.mutationObserver) this.mutationObserver.disconnect();
  }

  onSectionChange() {
    const currentButton = document.querySelector('.product-form__submit');
    if (currentButton && currentButton !== this.realButton) {
      if (this.observer) {
        this.observer.unobserve(this.realButton);
        this.observer.observe(currentButton);
      }
      this.realButton = currentButton;
    }
    this.realPrice = document.getElementById('total-price-' + this.sectionId)
      || document.getElementById('price-' + this.sectionId)
      || this.realPrice;
    this.sync();
  }

  sync() {
    if (this.realPrice && this.priceTarget) {
      const price = this.realPrice.querySelector('.price-item--regular, .price-item--sale, .price__regular .price-item');
      this.priceTarget.textContent = price
        ? price.textContent.replace(/\s+/g, ' ').trim()
        : this.realPrice.textContent.replace(/\s+/g, ' ').trim();
    }

    if (!this.realButton) return;

    this.button.disabled = this.realButton.disabled;

    const realLabel = this.realButton.querySelector('span');
    if (realLabel && this.label) {
      this.label.textContent = realLabel.textContent.replace(/\s+/g, ' ').trim();
    }
  }
}

if (!customElements.get('sticky-atc')) {
  customElements.define('sticky-atc', StickyAtc);
}